/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Help_TitleInputs */

const he_seo_help_title = /** @type {(inputs: Seo_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עזרה - Pricedrop`)
};

const en_seo_help_title = /** @type {(inputs: Seo_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Help - Pricedrop" |
*
* @param {Seo_Help_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_help_title = /** @type {((inputs?: Seo_Help_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Help_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_help_title(inputs)
	return en_seo_help_title(inputs)
});